module.exports = __webpack_public_path__ + "static/Kritapas_pic-a96a59332040c2f2219a128c028ed659.jpg";